import { Draft, Payload, State } from '@smile-next/uikit';
import { AuthParams } from '@/models/domain/AuthParams';
import { AuthenticatedFailurePayload } from '@/usecases/payload/AuthenticatedFailurePayload';
import { AuthenticatedSuccessPayload } from '@/usecases/payload/AuthenticatedSuccessPayload';
import { UpdatedCloudIdFormPayload } from '@/usecases/payload/UpdatedCloudIdFormPayload';

export class SSOLoginPageState extends State {
    public readonly isAuthenticated?: boolean;

    constructor(
        // prettier-ignore
        public readonly authParams?: AuthParams,
        public readonly errorMessage?: string,
    ) {
        super();
    }

    reduce(this: Draft<this>, payload: Payload) {
        if (payload instanceof UpdatedCloudIdFormPayload) {
            this.authParams = payload.authParams;
        }

        if (payload instanceof AuthenticatedSuccessPayload) {
            this.isAuthenticated = true;
        }

        if (payload instanceof AuthenticatedFailurePayload) {
            this.errorMessage = payload.authenticatedFailurePayloadArgs.error.message;
            this.isAuthenticated = false;
        }
    }

    get isValid() {
        return this.authParams?.cloudId?.isValid;
    }
}
